import { useMediaQuery, useTheme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import Flex from 'components/common/Flex';
import { AppTheme } from 'styles/theme';
import Text from './common/Text';
import { useTranslation } from 'react-i18next';
import { isMobileDevice } from 'utils/helper';
import {
  AndroidAppSharedButton,
  IOSAppSharedButton,
  FacebookSvg,
  InstagramSvg,
  TiktokSvg,
  TiktokBlackSvg,
  TwitterSvg,
  TelegramSvg,
  DiscordSvg
} from 'assets/icons';
import { useMemo } from 'react';
import useDepsContainer from 'hooks/useDepsContainer';
import Typography from '@material-ui/core/Typography';
import DownloadAndroidFooter from 'assets/images/download-android-footer.png';
import DownloadIosFooter from 'assets/images/download-ios-footer.png';
import DownloadApkFooter from 'assets/images/download-apk-footer.png';
import { useAppLink } from "hooks/useAppLink";

interface FooterProps {
  isHome?: boolean;
}

const Footer = (props: FooterProps) => {
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));
  const lgDown = useMediaQuery(theme.breakpoints.down('lg'));
  const styles = useStyles({
    ...props,
    mdDown
  });
  const { uiStore } = useDepsContainer();

  const { t, i18n } = useTranslation();
  const cachedT = useMemo(() => t, [t, uiStore.language]);

  const { toAppStore, toGooglePlay ,goAPK } = useAppLink();


  const Privacy = () => (
    <Typography component={'a'} href="/privacy" className={styles.value}>
      {cachedT('Privacy_2')}
    </Typography>
  );
  const Terms = () => (
    <Typography component={'a'} href="/terms" className={styles.value}>
      {cachedT('Terms')}
    </Typography>
  );
  const CookiePolicy = () => (
    <Typography component={'a'} href="/cookie" className={styles.value}>
      {cachedT('CookiePolicy')}
    </Typography>
  );
  const Guidelines = () => (
    <Typography component={'a'} href="/guidelines" className={styles.value}>
      {cachedT('Guidelines')}
    </Typography>
  );
  const PitchDeck = () => (
    <Typography component={'a'} href="deck.pdf" className={styles.value} target="deck">
      {cachedT('PitchDeck')}
    </Typography>
  );
  const ContactUsLabel = () => (
    <Typography component={'a'} href="mailto:support@pumpkin.xyz" className={styles.value}>
      {cachedT('ContactUsLabel')}
    </Typography>
  );

  const Brand = () => (
    <Typography component={'a'} href="/brand" className={styles.value}>
      {cachedT('FooterBrand')}
    </Typography>
  );

  const PumpkinDating = () => (
    <>
      <Text className={styles.label}>{cachedT('PumpkinDating')}</Text>
      <Text className={styles.valueTop} width={'90%'}>
        {cachedT('AllRightsReserved')}
      </Text>
    </>
  );

  const GeneralInquiries = () => (
    <>
      <Text className={styles.label}>{cachedT('GeneralInquiries')}</Text>
      <Text className={styles.valueTop}>{cachedT('GeneralInquiriesEmail')}</Text>
    </>
  );

  const SalesEmail = () => (
    <>
      <Text className={styles.label}>{cachedT(`Sales`)}</Text>
      <Text className={styles.valueTop}>{cachedT('SalesEmail')}</Text>
    </>
  );

  const CustomerCareEmail = () => (
    <>
      <Text className={styles.label}>{cachedT('CustomerCare')}</Text>
      <Text className={styles.valueTop}>{cachedT('CustomerCareEmail')}</Text>
    </>
  );

  const MediaList = () => {
    return (
      <Flex
        centerY
        center={mdDown}
        width={mdDown || lgDown ? '100%' : 'auto'}
        flexWrap={mdDown || lgDown ? 'wrap' : 'unset'}
        mt={mdDown ? 0 : lgDown ? '-80px' : 0}
      >
        <Flex width={'100%'} centerY center={mdDown || lgDown}>
          <Flex
            mr={4}
            cursorPointer
            onClick={() => {
              window.open('https://t.me/pumpkinglobal_group');
            }}
          >
            <TelegramSvg />
          </Flex>
          {/* <Flex
            mr={4}
            cursorPointer
            onClick={() => {
              window.open('https://discord.gg/CPPt4fqk7A');
            }}
          >
            <DiscordSvg />
          </Flex> */}
          <Flex
            mr={4}
            cursorPointer
            onClick={() => {
              if (uiStore.language == 'vn') {
                window.open('https://www.facebook.com/pumpkin.vietnam');
              } else {
                window.open('https://www.facebook.com/pumpkin.global.official');
              }
            }}
          >
            <FacebookSvg />
          </Flex>
          <Flex
            mr={4}
            cursorPointer
            onClick={() => {
              if (uiStore.language == 'vn') {
                window.open('https://www.tiktok.com/@pumpkinvietnam');
              } else {
                window.open('https://www.tiktok.com/@pumpkin_global');
              }
            }}
          >
            {props.isHome && <TiktokBlackSvg />}
            {!props.isHome && <TiktokSvg />}
          </Flex>
          <Flex mr={4} cursorPointer onClick={() => window.open('https://twitter.com/Pumpkin_global')}>
            <TwitterSvg />
          </Flex>
          <Flex
            cursorPointer
            onClick={() => {
              if (uiStore.language == 'vn') {
                window.open('https://www.instagram.com/pumpkin_vietnam');
              } else {
                window.open('https://www.instagram.com/pumpkin.global.official');
              }
            }}
          >
            <InstagramSvg />
          </Flex>
        </Flex>
      </Flex>
    );
  };

  return (
    <Flex bgcolor={props.isHome ? 'white' : 'header'} column width={'100%'} center pt={4} px={mdDown ? 14 : 4}>
      <Flex
        width={mdDown ? '100vw' : '100%'}
        maxWidth={mdDown ? '100vw' : '1280px'}
        style={mdDown ? {} : { borderBottom: props.isHome ? 'solid 1px #3B3C45' : 'solid 1px rgba(255,255,255, 0.12)' }}
        mt={3}
        pb={6}
        px={mdDown ? 6 : 0}
        column={mdDown || lgDown}
        justifyContent={'space-between'}
      >
        <Flex
          center={mdDown || lgDown}
          style={
            mdDown ? { borderBottom: props.isHome ? 'solid 1px #3B3C45' : 'solid 1px rgba(255,255,255, 0.12)' } : {}
          }
          pb={mdDown ? 6 : 0}
          column
        >
          <Flex>
            <svg
              width={mdDown ? '108' : lgDown ? '140' : '280'}
              viewBox="0 0 101 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.92627 25.9796C8.80572 26.9171 8.63037 27.7163 8.40023 28.3774C8.17008 29.0264 7.89062 29.5613 7.56185 29.982C7.23307 30.3906 6.85498 30.6851 6.42757 30.8654C6.01112 31.0577 5.55084 31.1538 5.04671 31.1538C4.33436 31.1538 3.66585 30.9255 3.04118 30.4688C2.42746 30.012 1.89594 29.3329 1.44661 28.4315C0.997287 27.5301 0.641113 26.4123 0.378092 25.0781C0.126031 23.744 0 22.1995 0 20.4447C0 18.6058 0.158908 16.8209 0.476725 15.0901C0.805501 13.3594 1.26579 11.7368 1.85758 10.2224C2.46034 8.70793 3.17817 7.32572 4.01107 6.07572C4.85493 4.8137 5.79194 3.73798 6.8221 2.84856C7.86323 1.94712 8.98655 1.25 10.1921 0.757212C11.3976 0.252404 12.6579 0 13.973 0C15.1018 0 16.1319 0.186298 17.0635 0.558894C17.995 0.93149 18.795 1.44832 19.4635 2.10938C20.1321 2.77043 20.6471 3.55168 21.0088 4.45313C21.3704 5.35457 21.5513 6.32813 21.5513 7.3738C21.5513 8.63582 21.3924 9.8137 21.0745 10.9075C20.7567 11.9892 20.3129 12.9808 19.743 13.8822C19.1841 14.7837 18.5156 15.5889 17.7375 16.2981C16.9594 17.0072 16.11 17.6082 15.1895 18.101C14.2798 18.5938 13.3154 18.9784 12.2962 19.2548C11.288 19.5192 10.2633 19.6695 9.22217 19.7055C9.18929 21.2079 9.15093 22.476 9.1071 23.5096C9.07422 24.5313 9.01394 25.3546 8.92627 25.9796ZM6.06592 18.4255C6.12071 18.4495 6.18647 18.4736 6.26318 18.4976C6.32894 18.5216 6.40565 18.5457 6.49333 18.5697C6.59196 18.5938 6.70703 18.6178 6.83854 18.6418C6.81662 17.1394 6.78923 15.7632 6.75635 14.5132C6.73443 13.2512 6.70703 12.1514 6.67415 11.2139C6.63032 10.1202 6.59196 9.13462 6.55908 8.25721C6.6358 8.1851 6.72347 8.125 6.8221 8.07692C6.90978 8.02885 7.01389 7.98678 7.13444 7.95072C7.25499 7.91466 7.40294 7.89664 7.57829 7.89664C8.08241 7.89664 8.4879 7.9988 8.79476 8.20312C9.10162 8.39543 9.25505 8.72596 9.25505 9.19471C9.25505 11.1779 9.25505 12.9567 9.25505 14.5313C9.25505 16.1058 9.24409 17.524 9.22217 18.7861C10.6578 18.7861 11.9565 18.4856 13.1182 17.8846C14.2908 17.2837 15.2881 16.4844 16.11 15.4868C16.932 14.4772 17.5676 13.3173 18.0169 12.0072C18.4663 10.6971 18.6909 9.32692 18.6909 7.89664C18.6909 6.98317 18.5758 6.11779 18.3457 5.30048C18.1265 4.47115 17.7868 3.75 17.3265 3.13702C16.8662 2.51202 16.2854 2.01923 15.584 1.65865C14.8936 1.28606 14.0771 1.09976 13.1346 1.09976C12.1812 1.09976 11.2387 1.29808 10.3071 1.69471C9.38656 2.09135 8.50434 2.6863 7.66048 3.47957C6.82758 4.27284 6.05496 5.25841 5.34261 6.4363C4.64122 7.61418 4.02751 8.99039 3.50146 10.5649C2.98638 12.1394 2.58089 13.9063 2.28499 15.8654C2.00005 17.8125 1.85758 19.9579 1.85758 22.3017C1.85758 23.3113 1.90142 24.2969 1.9891 25.2584C2.08773 26.2079 2.24664 27.0553 2.46582 27.8005C2.685 28.5337 2.97542 29.1226 3.33708 29.5673C3.70969 30.012 4.16998 30.2344 4.71794 30.2344C5.01383 30.2344 5.29329 30.1683 5.55631 30.0361C5.81934 29.9038 6.04948 29.6334 6.24674 29.2248C6.44401 28.8041 6.60292 28.2091 6.72347 27.4399C6.84402 26.6587 6.9043 25.619 6.9043 24.3209C6.9043 23.5036 6.89882 22.6983 6.88786 21.905C6.8769 21.0998 6.87142 20.3185 6.87142 19.5613C6.70703 19.5373 6.56456 19.5072 6.44401 19.4712C6.32346 19.4351 6.21935 19.405 6.13167 19.381C6.03304 19.345 5.95085 19.3089 5.88509 19.2728L6.06592 18.4255Z"
                fill={props.isHome ? '#FD746C' : '#C0C3D8'}
              />
              <path
                d="M26.9432 26.3221C26.8884 26.4183 26.8062 26.5865 26.6966 26.8269C26.598 27.0553 26.4665 27.3137 26.3021 27.6022C26.1487 27.8906 25.9623 28.1911 25.7432 28.5036C25.5349 28.8161 25.2938 29.0986 25.0199 29.351C24.7459 29.6034 24.439 29.8137 24.0993 29.982C23.7705 30.1502 23.4034 30.2344 22.9979 30.2344C22.6801 30.2344 22.3513 30.1623 22.0116 30.018C21.6718 29.8738 21.354 29.6094 21.0581 29.2248C20.7732 28.8401 20.5375 28.3173 20.3512 27.6563C20.1649 26.9832 20.0718 26.1178 20.0718 25.0601C20.0718 24.0505 20.1047 23.0409 20.1704 22.0313C20.2362 21.0096 20.3129 20.0781 20.4006 19.2368C20.4992 18.3954 20.5923 17.6923 20.68 17.1274C20.7677 16.5625 20.8334 16.22 20.8773 16.0998C20.9211 15.9916 21.0088 15.8954 21.1403 15.8113C21.2718 15.7272 21.4198 15.6611 21.5841 15.613C21.7595 15.5649 21.9348 15.5288 22.1102 15.5048C22.2965 15.4808 22.4554 15.4688 22.5869 15.4688C22.7623 15.4688 22.8993 15.5168 22.9979 15.613C23.1075 15.7091 23.1623 15.8714 23.1623 16.0998C23.1623 16.2079 23.1404 16.4243 23.0965 16.7488C23.0636 17.0613 23.0198 17.4459 22.965 17.9026C22.9102 18.3594 22.8499 18.8642 22.7842 19.4171C22.7294 19.97 22.6746 20.5349 22.6198 21.1118C22.565 21.6767 22.5157 22.2416 22.4718 22.8065C22.439 23.3594 22.4225 23.8642 22.4225 24.3209C22.4225 25.631 22.5486 26.6046 22.8006 27.2416C23.0636 27.8786 23.491 28.1971 24.0828 28.1971C24.587 28.1971 25.0966 27.7945 25.6117 26.9892C26.1377 26.1839 26.5925 25.012 26.9761 23.4736C27.0309 22.8245 27.0802 22.1334 27.124 21.4002C27.1788 20.655 27.2281 19.9519 27.272 19.2909C27.3158 18.6178 27.3542 18.0168 27.387 17.488C27.4309 16.9591 27.4692 16.5805 27.5021 16.3522C27.535 16.1839 27.6227 16.0457 27.7651 15.9375C27.9076 15.8173 28.0665 15.7272 28.2419 15.6671C28.4282 15.595 28.6035 15.5469 28.7679 15.5228C28.9433 15.4868 29.0748 15.4688 29.1624 15.4688C29.3487 15.4688 29.4748 15.5168 29.5405 15.613C29.6172 15.6971 29.6556 15.8353 29.6556 16.0276C29.6556 16.1959 29.6392 16.5204 29.6063 17.0012C29.5844 17.47 29.5515 18.0228 29.5077 18.6599C29.4748 19.2849 29.4364 19.9579 29.3926 20.6791C29.3487 21.4002 29.3049 22.0974 29.2611 22.7704C29.2282 23.4315 29.1953 24.0325 29.1624 24.5733C29.1405 25.1142 29.1296 25.5228 29.1296 25.7993C29.1296 26.6166 29.1679 27.2596 29.2446 27.7284C29.3323 28.1971 29.5186 28.4315 29.8035 28.4315C30.0118 28.4315 30.2364 28.2873 30.4775 27.9988C30.7296 27.6983 30.9981 27.2837 31.283 26.7548C31.5789 26.226 31.8968 25.601 32.2365 24.8798C32.5762 24.1466 32.9434 23.3474 33.3379 22.482L33.5023 22.1034L34.1763 22.6623L34.0119 23.0409C33.4858 24.1827 33.0201 25.2043 32.6146 26.1058C32.2201 26.9952 31.842 27.7464 31.4803 28.3594C31.1187 28.9724 30.7515 29.4411 30.3789 29.7656C30.0063 30.0781 29.5898 30.2344 29.1296 30.2344C28.7021 30.2344 28.346 30.1442 28.061 29.9639C27.7871 29.7837 27.5679 29.5252 27.4035 29.1887C27.2391 28.8522 27.1185 28.4435 27.0418 27.9627C26.9761 27.482 26.9432 26.9351 26.9432 26.3221Z"
                fill={props.isHome ? '#FD746C' : '#C0C3D8'}
              />
              <path
                d="M38.8778 16.7488C38.56 16.7488 38.2531 16.875 37.9572 17.1274C37.6723 17.3678 37.3983 17.7043 37.1353 18.137C36.8722 18.5577 36.6147 19.0565 36.3626 19.6334C36.1215 20.1983 35.8804 20.8053 35.6393 21.4543V21.6707C35.6064 22.7284 35.5736 23.8522 35.5407 25.0421C35.5188 26.232 35.5078 27.5301 35.5078 28.9363C35.5078 29.1767 35.4311 29.381 35.2777 29.5493C35.1352 29.7055 34.9653 29.8377 34.7681 29.9459C34.5708 30.0421 34.3681 30.1142 34.1598 30.1623C33.9516 30.2103 33.7817 30.2344 33.6502 30.2344C33.4858 30.2344 33.3324 30.1803 33.1899 30.0721C33.0475 29.9639 32.9762 29.7236 32.9762 29.351C32.9762 29.1707 32.9927 28.9483 33.0256 28.6839C33.0584 28.4075 33.1023 28.113 33.1571 27.8005C33.2009 27.488 33.2557 27.1695 33.3215 26.845C33.3762 26.5084 33.431 26.1959 33.4858 25.9075C33.4858 24.8858 33.4858 23.9663 33.4858 23.149C33.4749 22.3317 33.4694 21.6046 33.4694 20.9675C33.4694 20.3305 33.4694 19.7716 33.4694 19.2909C33.4584 18.8101 33.453 18.3954 33.453 18.0469C33.453 17.47 33.4639 17.0493 33.4858 16.7849C33.4968 16.5084 33.5187 16.3161 33.5516 16.2079C33.6064 16.0397 33.705 15.9075 33.8475 15.8113C34.0009 15.7151 34.1598 15.643 34.3242 15.595C34.4886 15.5349 34.653 15.4988 34.8174 15.4868C34.9818 15.4748 35.1078 15.4688 35.1955 15.4688C35.4037 15.4688 35.5407 15.5349 35.6064 15.6671C35.6722 15.7993 35.7051 16.0036 35.7051 16.28C35.7051 16.905 35.7051 17.47 35.7051 17.9748C35.7051 18.4796 35.6941 18.9844 35.6722 19.4892C35.8804 18.9483 36.1215 18.4375 36.3955 17.9567C36.6804 17.4639 36.9928 17.0373 37.3325 16.6767C37.6723 16.3041 38.0284 16.0096 38.401 15.7933C38.7846 15.5769 39.1791 15.4688 39.5846 15.4688C40.0778 15.4688 40.4833 15.5829 40.8011 15.8113C41.1299 16.0276 41.3874 16.3341 41.5737 16.7308C41.771 17.1274 41.9135 17.5962 42.0011 18.137C42.0998 18.6659 42.1655 19.2428 42.1984 19.8678C42.5053 19.2548 42.834 18.6839 43.1847 18.155C43.5464 17.6142 43.9245 17.1454 44.319 16.7488C44.7245 16.3522 45.1464 16.0397 45.5848 15.8113C46.0341 15.5829 46.4999 15.4688 46.9821 15.4688C47.815 15.4688 48.4232 15.7572 48.8068 16.3341C49.1904 16.899 49.3822 17.6683 49.3822 18.6418C49.3822 19.2548 49.3383 19.9399 49.2507 20.6971C49.163 21.4543 49.0698 22.2236 48.9712 23.0048C48.8726 23.774 48.7794 24.5313 48.6917 25.2764C48.6041 26.0216 48.5602 26.7007 48.5602 27.3137C48.5602 28.0589 48.7301 28.4315 49.0698 28.4315C49.2452 28.4315 49.437 28.3173 49.6452 28.0889C49.8534 27.8486 50.089 27.488 50.3521 27.0072C50.626 26.5144 50.9384 25.8954 51.2891 25.1502C51.6507 24.4051 52.0672 23.5156 52.5384 22.482L52.7028 22.1034L53.3768 22.6623L53.2124 23.0409C52.5658 24.4591 52.0124 25.631 51.5521 26.5565C51.1028 27.482 50.6973 28.2212 50.3356 28.774C49.974 29.3149 49.6287 29.6935 49.3 29.9099C48.9822 30.1262 48.626 30.2344 48.2314 30.2344C48.0013 30.2344 47.7766 30.1983 47.5575 30.1262C47.3383 30.0541 47.1465 29.9279 46.9821 29.7476C46.8177 29.5673 46.6862 29.3269 46.5876 29.0264C46.4889 28.7139 46.4396 28.3173 46.4396 27.8365C46.4396 27.1154 46.4835 26.3041 46.5711 25.4026C46.6588 24.5012 46.7574 23.5998 46.867 22.6983C46.9766 21.7969 47.0752 20.9495 47.1629 20.1563C47.2506 19.351 47.2944 18.6959 47.2944 18.1911C47.2944 17.7464 47.2068 17.3918 47.0314 17.1274C46.8561 16.851 46.593 16.7127 46.2424 16.7127C45.8917 16.7127 45.5245 16.863 45.1409 17.1635C44.7683 17.4639 44.4012 17.8546 44.0396 18.3353C43.6889 18.8041 43.3546 19.3329 43.0368 19.9219C42.7299 20.5108 42.4614 21.0938 42.2313 21.6707C42.2313 22.9327 42.2203 24.0385 42.1984 24.988C42.1765 25.9255 42.1436 26.7188 42.0998 27.3678C42.0669 28.0168 42.0176 28.5337 41.9518 28.9183C41.8861 29.2909 41.8148 29.5433 41.7381 29.6755C41.6833 29.7596 41.5902 29.8377 41.4587 29.9099C41.3271 29.982 41.1792 30.0421 41.0148 30.0901C40.8614 30.1382 40.708 30.1743 40.5545 30.1983C40.4121 30.2224 40.3025 30.2344 40.2257 30.2344C40.0504 30.2344 39.897 30.1803 39.7655 30.0721C39.6449 29.9519 39.5846 29.7236 39.5846 29.387C39.5846 29.2308 39.5956 29.0204 39.6175 28.756C39.6504 28.4916 39.6887 28.1971 39.7326 27.8726C39.7764 27.5481 39.8257 27.1995 39.8805 26.8269C39.9353 26.4543 39.9901 26.0757 40.0449 25.6911C40.0559 25.3305 40.0668 24.9279 40.0778 24.4832C40.0888 24.0385 40.0997 23.5998 40.1107 23.1671C40.1216 22.7224 40.1271 22.3017 40.1271 21.905C40.1381 21.4964 40.1436 21.1478 40.1436 20.8594C40.1436 20.2464 40.1271 19.6875 40.0942 19.1827C40.0614 18.6779 39.9956 18.2452 39.897 17.8846C39.8093 17.524 39.6833 17.2476 39.5189 17.0553C39.3545 16.851 39.1408 16.7488 38.8778 16.7488Z"
                fill={props.isHome ? '#FD746C' : '#C0C3D8'}
              />
              <path
                d="M54.8727 18.8582C55.059 18.4135 55.2837 17.9868 55.5467 17.5781C55.8097 17.1695 56.1111 16.8089 56.4508 16.4964C56.7906 16.1839 57.1687 15.9375 57.5851 15.7572C58.0016 15.5649 58.4564 15.4688 58.9495 15.4688C59.6071 15.4688 60.1879 15.643 60.6921 15.9916C61.1962 16.3281 61.6181 16.7849 61.9578 17.3618C62.2976 17.9267 62.5551 18.5877 62.7305 19.345C62.9058 20.0901 62.9935 20.8654 62.9935 21.6707C62.9935 22.9087 62.8784 24.0264 62.6483 25.024C62.4291 26.0096 62.1277 26.875 61.7441 27.6202C62.3359 27.1274 62.9332 26.4724 63.536 25.6551C64.1497 24.8377 64.7524 23.7801 65.3442 22.482L65.5086 22.1034L66.1826 22.6623L66.0182 23.0409C65.5141 24.1466 64.9607 25.1442 64.3579 26.0337C63.7552 26.9231 63.114 27.6803 62.4346 28.3053C61.7661 28.9183 61.0647 29.393 60.3304 29.7296C59.5961 30.0661 58.8454 30.2344 58.0783 30.2344C57.3988 30.2344 56.7687 30.0721 56.1878 29.7476C55.6179 29.4231 55.1796 29.0204 54.8727 28.5397V37.0673C54.8727 37.524 54.8398 37.9026 54.7741 38.2031C54.7193 38.5156 54.6207 38.762 54.4782 38.9423C54.3467 39.1346 54.1659 39.2668 53.9357 39.3389C53.7056 39.4231 53.4261 39.4651 53.0973 39.4651C52.8453 39.4651 52.6699 39.4171 52.5713 39.3209C52.4727 39.2368 52.4233 39.0986 52.4233 38.9063C52.4233 38.8221 52.4343 38.6719 52.4562 38.4555C52.4781 38.2392 52.5001 37.9087 52.522 37.4639C52.5439 37.0313 52.5658 36.4543 52.5877 35.7332C52.6096 35.024 52.6206 34.1166 52.6206 33.0108V23.0409C52.6206 21.7067 52.6151 20.643 52.6042 19.8498C52.5932 19.0445 52.5822 18.4195 52.5713 17.9748C52.5603 17.518 52.5494 17.1935 52.5384 17.0012C52.5275 16.8089 52.522 16.6406 52.522 16.4964C52.522 16.3762 52.5768 16.256 52.6864 16.1358C52.796 16.0156 52.9384 15.9075 53.1138 15.8113C53.2891 15.7151 53.4754 15.637 53.6727 15.5769C53.8809 15.5048 54.0782 15.4688 54.2645 15.4688C54.4508 15.4688 54.5987 15.5228 54.7083 15.631C54.8179 15.7392 54.8727 15.9315 54.8727 16.2079V18.8582ZM58.0783 17.0553C57.618 17.0553 57.1906 17.2296 56.7961 17.5781C56.4125 17.9267 56.0782 18.3774 55.7933 18.9303C55.5193 19.4712 55.3001 20.0721 55.1357 20.7332C54.9823 21.3942 54.9056 22.0373 54.9056 22.6623V24.7356C54.9056 25.3846 54.9823 25.9736 55.1357 26.5024C55.3001 27.0313 55.5138 27.482 55.7769 27.8546C56.0399 28.2272 56.3467 28.5156 56.6974 28.72C57.0591 28.9123 57.4372 29.0084 57.8317 29.0084C58.7632 29.0084 59.4646 28.4796 59.9359 27.4219C60.4181 26.3642 60.6592 24.7055 60.6592 22.4459C60.6592 21.6767 60.6099 20.9615 60.5112 20.3005C60.4126 19.6394 60.2592 19.0685 60.0509 18.5877C59.8427 18.107 59.5742 17.7344 59.2454 17.47C58.9167 17.1935 58.5276 17.0553 58.0783 17.0553Z"
                fill={props.isHome ? '#FD746C' : '#C0C3D8'}
              />
              <path
                d="M79.4159 22.6623L79.2515 23.0409C78.7912 24.0505 78.3528 24.994 77.9364 25.8714C77.5199 26.7488 77.1035 27.512 76.687 28.1611C76.2706 28.8101 75.8432 29.3209 75.4048 29.6935C74.9774 30.0541 74.5171 30.2344 74.0239 30.2344C73.5308 30.2344 73.0486 30.0901 72.5773 29.8017C72.1061 29.5132 71.6348 29.1106 71.1636 28.5938C70.7033 28.0769 70.2375 27.476 69.7663 26.7909C69.306 26.0938 68.8293 25.3365 68.3361 24.5192L67.7607 24.6274C67.7388 25.6851 67.7059 26.6406 67.6621 27.494C67.6183 28.3353 67.5635 29.0264 67.4977 29.5673C67.4648 29.8077 67.3717 29.982 67.2183 30.0901C67.0758 30.1863 66.8785 30.2344 66.6265 30.2344C66.3306 30.2344 66.084 30.1923 65.8867 30.1082C65.6895 30.024 65.536 29.9219 65.4264 29.8017C65.3059 29.6695 65.2237 29.5313 65.1798 29.387C65.1251 29.2308 65.0977 29.0805 65.0977 28.9363C65.0977 28.1671 65.2127 27.2115 65.4429 26.0697V16.7488C65.4429 14.4411 65.5525 12.4459 65.7716 10.7632C65.9908 9.06851 66.2867 7.66827 66.6593 6.5625C67.032 5.44471 67.4648 4.62139 67.958 4.09255C68.4621 3.55168 68.9937 3.28125 69.5526 3.28125C70.1553 3.28125 70.5827 3.4976 70.8348 3.93029C71.0978 4.35096 71.2293 4.93389 71.2293 5.67909C71.2293 6.32813 71.1417 7.16346 70.9663 8.1851C70.791 9.19471 70.5444 10.3065 70.2266 11.5204C69.9197 12.7344 69.5581 14.0024 69.1416 15.3245C68.7252 16.6346 68.2758 17.9147 67.7936 19.1647V19.5613C68.1005 19.0204 68.4566 18.5036 68.8621 18.0108C69.2786 17.518 69.7224 17.0853 70.1937 16.7127C70.6649 16.3281 71.1471 16.0276 71.6403 15.8113C72.1444 15.5829 72.6376 15.4688 73.1198 15.4688C73.5472 15.4688 73.9363 15.5349 74.2869 15.6671C74.6486 15.7993 74.9609 15.9916 75.224 16.244C75.487 16.4964 75.6897 16.8149 75.8322 17.1995C75.9747 17.5721 76.0459 18.0048 76.0459 18.4976C76.0459 19.0024 75.9418 19.5072 75.7336 20.012C75.5363 20.5168 75.2185 21.0036 74.7801 21.4724C74.3527 21.9411 73.7993 22.3858 73.1198 22.8065C72.4403 23.2151 71.6184 23.5757 70.654 23.8882C70.7197 23.9964 70.8293 24.1767 70.9827 24.4291C71.1362 24.6815 71.317 24.97 71.5252 25.2945C71.7444 25.607 71.98 25.9375 72.2321 26.2861C72.4842 26.6226 72.7417 26.9351 73.0047 27.2236C73.2787 27.5 73.5472 27.7344 73.8102 27.9267C74.0732 28.107 74.3143 28.1971 74.5335 28.1971C74.8294 28.1971 75.1308 28.0649 75.4377 27.8005C75.7445 27.524 76.0623 27.1394 76.3911 26.6466C76.7309 26.1418 77.0815 25.5409 77.4432 24.8438C77.8048 24.1346 78.1829 23.3474 78.5775 22.482L78.7419 22.1034L79.4159 22.6623ZM67.7936 21.1118C67.7936 21.3882 67.7881 21.6346 67.7772 21.851C67.7772 22.0553 67.7772 22.2596 67.7772 22.4639C67.7772 22.6563 67.7717 22.8546 67.7607 23.0589C67.7607 23.2632 67.7607 23.4916 67.7607 23.744C68.8786 23.5637 69.8211 23.3233 70.5882 23.0228C71.3663 22.7224 71.9965 22.3738 72.4787 21.9772C72.9609 21.5805 73.3116 21.1478 73.5308 20.6791C73.7499 20.1983 73.8595 19.6935 73.8595 19.1647C73.8595 18.8882 73.8157 18.6238 73.728 18.3714C73.6513 18.107 73.5362 17.8786 73.3828 17.6863C73.2294 17.482 73.0376 17.3197 72.8075 17.1995C72.5883 17.0793 72.3417 17.0192 72.0677 17.0192C71.6841 17.0192 71.2951 17.1334 70.9006 17.3618C70.517 17.5781 70.1334 17.8726 69.7498 18.2452C69.3772 18.6178 69.021 19.0565 68.6813 19.5613C68.3525 20.0541 68.0566 20.5709 67.7936 21.1118ZM69.2402 4.20072C69.0101 4.20072 68.8074 4.44712 68.632 4.9399C68.4676 5.43269 68.3251 6.20192 68.2046 7.2476C68.084 8.28125 67.9854 9.60337 67.9087 11.2139C67.832 12.8125 67.7717 14.7236 67.7279 16.9471C68.1881 15.613 68.5608 14.363 68.8457 13.1971C69.1306 12.0192 69.3498 10.9615 69.5033 10.024C69.6676 9.07452 69.7772 8.2512 69.832 7.55409C69.8868 6.84495 69.9142 6.28005 69.9142 5.85938C69.9142 5.22236 69.8594 4.78966 69.7498 4.5613C69.6512 4.32091 69.4813 4.20072 69.2402 4.20072Z"
                fill={props.isHome ? '#FD746C' : '#C0C3D8'}
              />
              <path
                d="M79.5967 22.3017L79.4323 22.6623L79.2679 23.0409L78.5939 22.482L78.7583 22.1034C79.0323 21.4904 79.2569 20.8774 79.4323 20.2644C79.6186 19.6394 79.7665 19.0565 79.8761 18.5156C79.9967 17.9748 80.0953 17.5 80.172 17.0913C80.2488 16.6827 80.3255 16.3882 80.4022 16.2079C80.4679 16.0637 80.5611 15.9495 80.6816 15.8654C80.8131 15.7692 80.9447 15.6911 81.0762 15.631C81.2186 15.5709 81.3502 15.5288 81.4707 15.5048C81.6022 15.4808 81.6954 15.4688 81.7502 15.4688C81.9913 15.4688 82.1502 15.5228 82.2269 15.631C82.3146 15.7392 82.3584 15.9315 82.3584 16.2079C82.3584 16.3401 82.331 16.6707 82.2762 17.1995C82.2324 17.7163 82.1776 18.3714 82.1118 19.1647C82.057 19.9459 82.0022 20.8293 81.9474 21.8149C81.9036 22.7885 81.8817 23.7981 81.8817 24.8438C81.8817 25.601 81.9146 26.2019 81.9803 26.6466C82.0461 27.0793 82.1283 27.4038 82.2269 27.6202C82.3365 27.8365 82.4516 27.9748 82.5721 28.0349C82.7036 28.095 82.8351 28.125 82.9666 28.125C83.142 28.125 83.3392 28.0409 83.5584 27.8726C83.7776 27.7043 84.0352 27.4099 84.3311 26.9892C84.627 26.5565 84.9667 25.9796 85.3503 25.2584C85.7338 24.5252 86.1832 23.5998 86.6982 22.482L86.8791 22.1034L87.5531 22.6623L87.3722 23.0409C86.9558 23.9303 86.5393 24.8077 86.1229 25.6731C85.7174 26.5385 85.3009 27.3077 84.8735 27.9808C84.4571 28.6538 84.0352 29.2007 83.6077 29.6214C83.1803 30.0301 82.7529 30.2344 82.3255 30.2344C81.8762 30.2344 81.4871 30.1382 81.1584 29.9459C80.8406 29.7416 80.5721 29.4111 80.3529 28.9543C80.1446 28.4976 79.9857 27.8966 79.8761 27.1514C79.7775 26.3942 79.7282 25.4627 79.7282 24.357C79.7282 24.0445 79.7282 23.72 79.7282 23.3834C79.7282 23.0349 79.7392 22.6743 79.7611 22.3017H79.5967ZM82.9666 11.7728C82.9666 12.1935 82.8351 12.5481 82.5721 12.8365C82.32 13.113 82.0022 13.2512 81.6187 13.2512C81.246 13.2512 80.9282 13.113 80.6652 12.8365C80.4022 12.5481 80.2707 12.1935 80.2707 11.7728C80.2707 11.3642 80.4022 11.0156 80.6652 10.7272C80.9282 10.4387 81.246 10.2945 81.6187 10.2945C82.0022 10.2945 82.32 10.4387 82.5721 10.7272C82.8351 11.0156 82.9666 11.3642 82.9666 11.7728Z"
                fill={props.isHome ? '#FD746C' : '#C0C3D8'}
              />
              <path
                d="M93.208 16.7127C92.9012 16.7127 92.5559 16.863 92.1724 17.1635C91.7998 17.4639 91.4217 17.8546 91.0381 18.3353C90.6545 18.8041 90.2819 19.3329 89.9202 19.9219C89.5696 20.5108 89.2627 21.0938 88.9997 21.6707C88.9668 22.7284 88.9339 23.8822 88.901 25.1322C88.8791 26.3822 88.8682 27.7163 88.8682 29.1346C88.8682 29.3149 88.7915 29.4772 88.638 29.6214C88.4956 29.7536 88.3257 29.8678 88.1284 29.9639C87.9312 30.0481 87.7284 30.1142 87.5202 30.1623C87.312 30.2103 87.1421 30.2344 87.0106 30.2344C86.8462 30.2344 86.6928 30.1803 86.5503 30.0721C86.4078 29.9639 86.3366 29.7236 86.3366 29.351C86.3366 29.1707 86.353 28.9483 86.3859 28.6839C86.4188 28.4075 86.4626 28.113 86.5174 27.8005C86.5613 27.488 86.6161 27.1695 86.6818 26.845C86.7366 26.5084 86.7914 26.1959 86.8462 25.9075V17.0913C86.8462 16.851 86.8517 16.6647 86.8626 16.5325C86.8626 16.3882 86.8791 16.28 86.9119 16.2079C86.9777 16.0397 87.0928 15.9075 87.2572 15.8113C87.4215 15.7151 87.5969 15.643 87.7832 15.595C87.9695 15.5349 88.1503 15.4988 88.3257 15.4868C88.501 15.4748 88.638 15.4688 88.7367 15.4688C88.923 15.4688 89.049 15.5228 89.1147 15.631C89.1915 15.7392 89.2298 15.9315 89.2298 16.2079C89.2298 16.1719 89.2024 16.4663 89.1476 17.0913C89.1038 17.7163 89.0654 18.6118 89.0326 19.7776C89.3613 19.2127 89.7175 18.6719 90.1011 18.155C90.4846 17.6382 90.8847 17.1815 91.3011 16.7849C91.7176 16.3882 92.145 16.0697 92.5833 15.8293C93.0327 15.5889 93.4875 15.4688 93.9478 15.4688C94.7697 15.4688 95.3725 15.7572 95.756 16.3341C96.1396 16.899 96.3314 17.6683 96.3314 18.6418C96.3314 19.2548 96.293 19.9399 96.2163 20.6971C96.1506 21.4423 96.0684 22.2055 95.9697 22.9868C95.8821 23.756 95.7999 24.5132 95.7231 25.2584C95.6574 25.9916 95.6245 26.6647 95.6245 27.2776C95.6245 28.0709 95.8492 28.4676 96.2985 28.4676C96.441 28.4676 96.6054 28.3894 96.7917 28.2332C96.9889 28.0649 97.23 27.7584 97.515 27.3137C97.8109 26.869 98.1616 26.262 98.5671 25.4928C98.9725 24.7115 99.4548 23.7079 100.014 22.482L100.178 22.1034L100.852 22.6623L100.688 23.0409C100.03 24.4832 99.4438 25.6671 98.9287 26.5926C98.4246 27.518 97.9643 28.2512 97.5479 28.7921C97.1314 29.3329 96.7423 29.7115 96.3807 29.9279C96.019 30.1322 95.6574 30.2344 95.2957 30.2344C95.0656 30.2344 94.8354 30.1983 94.6053 30.1262C94.3752 30.0541 94.1724 29.9279 93.9971 29.7476C93.8217 29.5673 93.6793 29.3269 93.5697 29.0264C93.4601 28.7139 93.4053 28.3173 93.4053 27.8365C93.4053 27.1154 93.4491 26.3041 93.5368 25.4026C93.6245 24.5012 93.7231 23.5998 93.8327 22.6983C93.9423 21.7969 94.0409 20.9495 94.1286 20.1563C94.2163 19.351 94.2601 18.6959 94.2601 18.1911C94.2601 17.7464 94.1724 17.3918 93.9971 17.1274C93.8217 16.851 93.5587 16.7127 93.208 16.7127Z"
                fill={props.isHome ? '#FD746C' : '#C0C3D8'}
              />
            </svg>
          </Flex>
          <Flex width={'100%'} center={mdDown || lgDown} mt={6}>
            <Flex style={{ 'position': 'relative' }} mx={1} onClick={toAppStore} cursorPointer>
              <img width={mdDown ? 101 : 140} height={mdDown ? 30 : 41} src={DownloadIosFooter} />
              <div
                className={mdDown ? styles.downloadBtnMd : styles.downloadBtn}
                dangerouslySetInnerHTML={{ __html: t('DownloadIOS') }}
                lang={uiStore.language}
              />
            </Flex>
            <Flex style={{ 'position': 'relative' }} mx={1} onClick={toGooglePlay} cursorPointer>
              <img width={mdDown ? 101 : 140} height={mdDown ? 30 : 41} src={DownloadAndroidFooter} />
              <div
                className={mdDown ? styles.downloadBtnMd : styles.downloadBtn}
                dangerouslySetInnerHTML={{ __html: t('DownloadAndroid') }}
                lang={uiStore.language}
              />
            </Flex>
            <Flex style={{'position':'relative'}} mx={1} onClick={goAPK} cursorPointer>
              <img
                width={mdDown ? 101 : 140}
                height={mdDown ? 30 : 41}
                src={DownloadApkFooter}
              />
              <div className={mdDown ? styles.downloadBtnMd: styles.downloadBtn} dangerouslySetInnerHTML={{ __html: t('DownloadApk') }} lang={uiStore.language} />
            </Flex>
          </Flex>
        </Flex>
        {mdDown ? (
          <Flex pt={6} width={'80%'} margin={'0 auto'} column>
            <Flex justifyContent={'space-between'}>
              <Flex column>
                <PumpkinDating />
              </Flex>
              <Flex column>
                <GeneralInquiries />
              </Flex>
            </Flex>
            <Flex mt={6} justifyContent={'space-between'}>
              <Flex column>
                <SalesEmail />
              </Flex>
              <Flex column>
                <CustomerCareEmail />
              </Flex>
            </Flex>
          </Flex>
        ) : (
          <Flex width={lgDown ? '100%' : 'auto'} mt={lgDown ? 10 : 0} mb={lgDown ? 10 : 0} center={lgDown}>
            <Flex ml={lgDown ? 0 : 60} flexWrap={'wrap'}>
              <Flex width={'50%'} column center={lgDown}>
                <PumpkinDating />
              </Flex>
              <Flex width={'50%'} pl={mdDown ? 11 : 15} column center={lgDown}>
                <GeneralInquiries />
              </Flex>
              <Flex width={'50%'} mt={mdDown ? 4 : 8} column center={lgDown}>
                <SalesEmail />
              </Flex>
              <Flex width={'50%'} pl={mdDown ? 11 : 15} mt={mdDown ? 4 : 8} column center={lgDown}>
                <CustomerCareEmail />
              </Flex>
            </Flex>
          </Flex>
        )}
      </Flex>
      <Flex
        width={mdDown ? '100vw' : '100%'}
        maxWidth={mdDown ? '100vw' : '1280px'}
        my={mdDown ? 0 : 4}
        mb={4}
        px={mdDown ? 6 : 0}
        justifyContent={'space-between'}
        centerY
        flexWrap={'wrap'}
      >
        {(mdDown || lgDown) && <MediaList />}
        {mdDown ? (
          <Flex center mt={1} width={'100%'} height={120} column>
            <Flex width={'80%'} justifyContent={'space-between'}>
              <Privacy />
              <Terms />
              <CookiePolicy />
            </Flex>
            <Flex width={'100%'} justifyContent={'space-between'} mt={4}>
              <Guidelines />
              {/* <PitchDeck /> */}
              <Brand />
              <ContactUsLabel />
            </Flex>
          </Flex>
        ) : (
          <Flex width={lgDown ? '100%' : 'auto'} center={lgDown}>
            {/* <Flex mr={10}>
              <PitchDeck />
            </Flex> */}
            <Flex mr={10}>
              <Brand />
            </Flex>
            <Flex mr={10}>
              <Privacy />
            </Flex>
            <Flex mr={10}>
              <Terms />
            </Flex>
            <Flex mr={10}>
              <Guidelines />
            </Flex>
            <Flex mr={10}>
              <CookiePolicy />
            </Flex>
            <Flex mr={10}>
              <ContactUsLabel />
            </Flex>
          </Flex>
        )}
        {!mdDown && !lgDown && <MediaList />}
      </Flex>
    </Flex>
  );
};

const useStyles = makeStyles((theme: AppTheme) =>
  createStyles({
    bg: {},
    label: {
      fontFamily: 'Nohemi !important',
      fontStyle: 'normal !important',
      fontWeight: '500 !important',
      fontSize: (props: any) => (props.mdDown ? '14px !important' : '16x !important'),
      lineHeight: (props: any) => (props.mdDown ? '20px !important' : '24px !important'),
      letterSpacing: '-0.2px !important',
      color: (props: any) => (props.isHome ? '#000 !important' : '#000 !important')
    },
    valueTop: {
      fontFamily: 'Nohemi !important',
      fontStyle: 'normal !important',
      fontWeight: '300 !important',
      fontSize: (props: any) => (props.mdDown ? '12px !important' : '16px !important'),
      lineHeight: (props: any) => (props.mdDown ? '16px !important' : '24px !important'),
      letterSpacing: '-0.2px !important',
      color: (props: any) => (props.isHome ? '#000 !important' : '#000 !important'),
      cursor: 'pointer'
      // '&:hover': {
      //   color: '#1765CF !important'
      // }
    },
    value: {
      fontFamily: 'Nohemi !important',
      fontStyle: 'normal !important',
      fontWeight: '500 !important',
      fontSize: (props: any) => (props.mdDown ? '12px !important' : '16px !important'),
      lineHeight: (props: any) => (props.mdDown ? '16px !important' : '24px !important'),
      letterSpacing: '-0.2px !important',
      color: (props: any) => (props.isHome ? '#000 !important' : '#000 !important'),
      cursor: 'pointer',
      '&:hover': {
        color: '#1765CF !important'
      }
    },
    downloadBtnMd: {
      position: 'absolute',
      top: '2px',
      left: '26px',
      transform: 'scale(0.8)',
      fontSize: '8px',
      color: '#FFF',
      lineHeight: '10px',

      '& strong': {
        fontFamily: 'Lexend',
        fontSize: '12px',
        display: 'block',
        lineHeight: '14px',
        letterSpacing: '-0.3px',
        fontWeight: '500',
        marginBottom: '1px',
        marginTop: '1px'
      },

      '&[lang="kr"]': {
        transform: 'scale(0.8)',
        fontSize: '8px',

        '& strong': {
          fontSize: '10px',
          letterSpacing: '-0.1px'
        }
      }
    },
    downloadBtn: {
      position: 'absolute',
      top: '5px',
      left: '38px',
      fontSize: '10px',
      color: '#FFF',
      lineHeight: '14px',
      marginBottom: '2px',

      '& strong': {
        fontFamily: 'Lexend',
        fontSize: '16px',
        display: 'block',
        lineHeight: '16px',
        letterSpacing: '-0.3px',
        fontWeight: '600',
        marginBottom: '2px'
      },

      '&[lang="kr"]': {
        fontSize: '9px',

        '& strong': {
          fontSize: '12px',
          letterSpacing: '-0.1px'
        }
      }
    }
  })
);

export default Footer;
